import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import * as auth from "@/store/modules/auth";
import * as caption from "@/store/modules/caption";
import * as symvolaio from "@/store/modules/symvolaio";
import * as lookups from "@/store/modules/lookups";
import {isEmpty} from "@/util/Helpers";


Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        contract: {
            Theme: "light", // theme can be light or dark
            LayoutType: "full-sidebar", // this can be full-sidebar, mini-sidebar
            Sidebar_drawer: false,
            Customizer_drawer: false,
            SidebarColor: "dark", //Change Sidebar Color || 'white', | "#2b2b2b" | "rgb(44, 59, 164)" | "rgb(96, 44, 164)" | "rgb(151, 210, 219)" | "rgb(77, 86, 100)"
            navbarColor: "orange",
            logoColor: "orange",
            setHorizontalLayout: false, // Horizontal layout
            Direction: "ltr", // possible value  rtl / ltr
            hasUnsavedChanges: false, // if any change become on state isDirty is true.
            isBusy: false,
            isValid: true
        }
    },
    mutations: {
        IS_VALID(state, payload) {
            // if ((payload.isUpdated && payload.isValid !== state.isValid) || (payload.isUpdated === payload.isValid && payload.isValid === false))
            state.contract.isValid = payload.isValid;
        },
        IS_BUSY(state, payload) {
            state.contract.isBusy = payload;
        },
        SET_THEME(state, payload) {
            state.contract.Theme = payload;
        },
        SET_LAYOUT_TYPE(state, payload) {
            if (!isEmpty(payload)) {
                state.contract.LayoutType = payload;
            }
            state.contract.setHorizontalLayout = false
        },
        SET_SIDEBAR_DRAWER(state, payload) {
            state.contract.Sidebar_drawer = payload;
        },
        SET_CUSTOMIZER_DRAWER(state, payload) {
            state.contract.Customizer_drawer = payload;
        },
        SET_SIDEBAR_COLOR(state, payload) {
            state.contract.SidebarColor = payload;
        },
        SET_NAVBAR_COLOR(state, payload) {
            state.contract.navbarColor = payload;
        },
        SET_LOGO_COLOR(state, payload) {
            state.contract.logoColor = payload;
        },
        SET_LAYOUT(state, payload) {
            state.contract.setHorizontalLayout = payload;
        },
        SET_DIRECTION(state, payload) {
            state.contract.Direction = payload;
        },
        SET_HAS_UNSAVED_CHANGES(state, payload) {
            state.contract.hasUnsavedChanges = payload;
        },
        SET_LOGOUT(state, dispatch) {
            dispatch('caption/resetState', {root: true})
            dispatch('auth/resetState', {root: true})
            dispatch('lookups/resetState', {root: true})
            dispatch('symvolaio/resetState', {root: true})
            state.contract.hasUnsavedChanges = false
            state.contract.isBusy = false
            state.contract.isValid = true
            window.localStorage.clear();
        },
    },
    actions: {
        isValid({commit}, payload) {
            commit("IS_VALID", payload);
        },
        isBusy({commit}, isBusy) {
            commit("IS_BUSY", isBusy);
        },
        setLayoutType({commit}, width) {
            commit("SET_LAYOUT_TYPE", width);
        },
        hasUnsavedChanges({commit}, hasUnsavedChanges) {
            commit("SET_HAS_UNSAVED_CHANGES", hasUnsavedChanges);
        },
        logout({commit, dispatch}) {
            commit('SET_LOGOUT', dispatch)
        }
    },
    getters: {
        isBusy: (state) => state.contract.isBusy,
        isValid: (state) => state.contract.isValid
    },
    modules: {auth, caption, symvolaio, lookups},
    plugins: [createPersistedState()],
});
